import { JsonConverter, JsonCustomConvert, JsonObject } from "json2typescript";
import { Frequency, FrequencyConverter } from "./frequency";

@JsonConverter
export class TerminationOmniConverter implements JsonCustomConvert<TerminationOmni> {
  serialize() { }
  deserialize(data: any): TerminationOmni {
    const omni = new TerminationOmni();
    const converter = new FrequencyConverter();
    omni.freq24 = converter.deserialize(data?.freq24 ?? data?.freq_24 ?? {});
    omni.freq5 = converter.deserialize(data?.freq5 ?? data?.freq_5 ?? {});
    omni.freq6 = converter.deserialize(data?.freq6 ?? data?.freq_6 ?? {});
    return omni;
  }
}
@JsonObject("TerminationOmni")
export class TerminationOmni {
    freq24: Frequency = new Frequency();
    freq5: Frequency = new Frequency();
    freq6: Frequency = new Frequency();
    
}
